var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"intro"},on:{"click":_vm.closeNav}},[_c('carousel',{attrs:{"cards":_vm.cards,"contactInfo":_vm.contactInfo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }